<template>
  <el-dialog
      title="会员分红列表"
      :visible.sync="visible"
      width="70%"
      :close-on-click-modal="false"
      :before-close="beforeCloseHandle">
    <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
      <el-table-column prop="memberId" label="会员ID" header-align="center" align="center"></el-table-column>
      <el-table-column prop="memberNick" label="会员名称" header-align="center" align="center"></el-table-column>
      <el-table-column label="账户类型" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.balanceType===1">现金</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="deviceCode" label="设备编码" header-align="center" align="center"></el-table-column>
      <el-table-column prop="shareBalance" label="金额" header-align="center" align="center"></el-table-column>
      <el-table-column prop="ugBalance" label="优果数量" header-align="center" align="center"></el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :total="total"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  name: "sharemoney-device",
  mixins: [mixinViewModule],
  data(){
    return {
      visible:false,
      // 设置属性
      mixinViewModuleOptions: {
        activatedIsNeed: false,    // 此页面是否在激活（进入）时，调用查询数据列表接口？
        getDataListURL: '/cp/sharemoney/devpage',       // 数据列表接口，API地址
        getDataListIsPage: true, // 数据列表接口，是否需要分页？
      },
      // 默认属性
      dataForm:{
        shareMoneyId:""
      },
      limit: 8,                  // 每页数
    }
  },
  methods:{
    init(id){
      this.visible=true;
      this.dataForm.shareMoneyId=id;
      this.getDataList();
    },
    beforeCloseHandle(){
      const that=this;
      that.visible=false;
    }
  }
}
</script>

<style scoped>

</style>